import { IsoDuration } from '../../types/iso-date';
import { assertDurationsForComparision } from '../helper/assert-durations-for-comparision.function';

export function sortDurations<T extends IsoDuration>(durations: T[], direction: 'asc' | 'desc' = 'asc'): T[] {
  return assertDurationsForComparision(...durations)
    .sort((a, b) => direction === 'asc' ? (a.ms - b.ms) : (b.ms - a.ms))
    .map(o => o.original);
}
